import Component from "../abstracts/Component";
import LookbookModalComponent from "./LookbookModalComponent";

export default class LookbookSubComponent extends Component {
    get SELECTORS() {
        return {
            modals: '.w-lookbook-modal',
            modalOpenButton: '[data-modal-open]',
        }
    }

    constructor(htmlEl) {
        super(htmlEl);

        this.modals = this.$component.querySelectorAll(this.SELECTORS.modals);
        this.modalComponents = [];
        this.modalOpenButton = this.$component.querySelectorAll(this.SELECTORS.modalOpenButton);
        this.modalContext = {
            isOpen:false
        }
    }

    bindEvents() {
        let ctx = this;

        if (this.modalOpenButton && this.modalOpenButton.length) {
            this.modalOpenButton.forEach(element => {
                element.addEventListener('click', (e) => this.openModal(e, ctx));
            });
        }
    }

    openModal(event, ctx) {
        if (!ctx.modalComponents?.length || this.modalContext.isOpen) return;
        let uuid = event.target.getAttribute('data-uuid') 
            ?? event.target.closest(this.SELECTORS.modalOpenButton)?.getAttribute('data-uuid') 
            ?? event.currentTarget.getAttribute('data-uuid');

        if (!uuid) return;
        const modal = ctx.modalComponents.find(comp => comp?.uuid === uuid);
        if (modal) {
            modal.openModal(this.modalContext);
            this.modalContext.isOpen = true;
        }
    }

    render() {
        this.bindEvents();

        if (this.modals && this.modals.length) {
            this.modals.forEach(element => {
                let component = new LookbookModalComponent(element);
                component.render();
                this.modalComponents.push(component);
            });
        }
    }
}